import React, { useEffect } from "react";

import { getCurrentUser } from "../redux/currentUserSlice/currentUser.thunk";
import { useDispatch, useSelector } from "react-redux";
import StyleProfileModalV2 from "../views/components/modals/StyleProfileModalV2";
import { useLocation } from "react-router-dom";
import { AUTH_ROUTES } from "../constant/route";

const GlobalContainer = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const store = useSelector((state) => state.user);
  const auth = useSelector((state) => state.auth);

  const { children } = props;
  const token = localStorage.getItem("accessToken");
  useEffect(() => {
    if (token) {
      dispatch(getCurrentUser());
    }
  }, [dispatch, store?.data?.data, auth.userData]);

  return (
    <>
      {children}
      {/* for V2 changes Style Profile data */}
      {[
        AUTH_ROUTES.APP_LOGIN,
        AUTH_ROUTES.APP_REGISTER,
        AUTH_ROUTES.ADMIN_LOGIN,
        AUTH_ROUTES.RESET_PASSWORD,
      ].includes(location.pathname) ? null : (
        <StyleProfileModalV2 />
      )}
      {/* for V2 changes Style Profile data */}
    </>
  );
};

export default GlobalContainer;
